import React from "react";
// import { UserView } from "../types/api";
import { ContextData } from "../types/App/Types";

const data: ContextData = {};

export const MainContext = React.createContext({
  data,
  setUser: (user: any) => {},
});
